<agr-form-dialog (cancel)="cancel()" [data]="data" [formGroup]="formGroup">
  <div class="layout--margin-horizontal">
    <h4>{{ 'legend.title' | translate }}</h4>
    <p>{{ 'legend.explanation' | translate }}</p>
    <p>{{ 'legend.codesCaption' | translate }}:</p>
    <ol type="A">
      <li>{{ 'legend.codeA' | translate }}</li>
      <li>{{ 'legend.codeB' | translate }}</li>
      <li>{{ 'legend.codeC' | translate }}</li>
    </ol>
    <p>{{ 'legend.emptyField' | translate }}.</p>
  </div>

  <div class="avoid-page-break">
    @if (data?.report?.cropAids?.length) {
      <mat-table
        [dataSource]="data.report.cropAids"
        class="table-wrapper cropfield-impact-table"
        data-test="environmental-impact-table"
      >
        <ng-container matColumnDef="name">
          <mat-header-cell *matHeaderCellDef class="flex__child flex__child-4 flex text--bold">
            <div class="text--right spacing--margin-right">
              <span class="text--bold">
                <ng-container
                  >{{ data.report.cropFieldName }}: {{ data.report.cropFieldArea | number: '1.0-2' }} ha
                  {{ data.report.cropName }}
                  {{ data.report.cropVarietyName ? '(' + data.report.cropVarietyName + ')' : '' }}</ng-container
                >
              </span>
            </div>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="organicMatterPercentage">
          <mat-header-cell *matHeaderCellDef class="flex__child flex__child-4 flex text--bold flex--justify-flex-end">
            <div class="text--right spacing--margin-right">
              <span class="text--right text--bold">
                <ng-container>{{
                  data.report.organicMatterPercentage
                    ? ('organicMatter' | translate) + ': ' + data.report.organicMatterPercentage + '%'
                    : ''
                }}</ng-container>
              </span>
            </div>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="cropAidGroup1">
          <mat-header-cell
            *matHeaderCellDef
            class="flex__child flex__child-2 flex text--bold header-with-background background-color--gray4"
          >
            <div class="text--right spacing--margin-right">
              <span class="text--bold">
                <ng-container>{{ 'cropAid' | translate }}</ng-container>
              </span>
            </div>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="cropAidGroup2">
          <mat-header-cell
            *matHeaderCellDef
            class="flex__child flex__child-2 flex text--bold header-with-background background-color--gray4"
          >
            <div class="text--right spacing--margin-right">
              <span class="text--bold">
                <ng-container></ng-container>
              </span>
            </div>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="cropAidGroup3">
          <mat-header-cell
            *matHeaderCellDef
            class="flex__child flex__child-2 flex text--bold header-with-background background-color--gray4"
          >
            <div class="text--right spacing--margin-right">
              <span class="text--bold">
                <ng-container></ng-container>
              </span>
            </div>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="cropAidGroup4">
          <mat-header-cell
            *matHeaderCellDef
            class="flex__child flex__child-2 flex text--bold header-with-background background-color--gray4"
          >
            <div class="text--right spacing--margin-right">
              <span class="text--bold">
                <ng-container></ng-container>
              </span>
            </div>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="environMentalImpactPointsGroup1">
          <mat-header-cell
            *matHeaderCellDef
            class="flex__child flex__child-2 flex text--bold descriptive-cell header-with-background background-color--gray4"
            style="justify-content: right"
          >
            <div class="text--right spacing--margin-right">
              <span class="text--bold">
                <ng-container>{{ 'environmentalImpactPoints' | translate }}</ng-container>
              </span>
            </div>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="environMentalImpactPointsGroup2">
          <mat-header-cell
            *matHeaderCellDef
            class="flex__child flex__child-2 flex text--bold header-with-background background-color--gray4"
          >
            <div class="text--right spacing--margin-right">
              <span class="text--bold">
                <ng-container></ng-container>
              </span>
            </div>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="environMentalImpactPointsGroup3">
          <mat-header-cell
            *matHeaderCellDef
            class="flex__child flex__child-2 flex text--bold header-with-background background-color--gray4"
          >
            <div class="text--right spacing--margin-right">
              <span class="text--bold">
                <ng-container></ng-container>
              </span>
            </div>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="usableOrganismsGroup1">
          <mat-header-cell
            *matHeaderCellDef
            class="flex__child flex__child-2 flex text--bold descriptive-cell header-with-background background-color--gray4"
            style="justify-content: center"
          >
            <div class="text--right spacing--margin-right">
              <span class="text--bold">
                <ng-container>{{ 'usableOrganisms' | translate }}</ng-container>
              </span>
            </div>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="usableOrganismsGroup2">
          <mat-header-cell
            *matHeaderCellDef
            class="flex__child flex__child-2 flex text--bold header-with-background background-color--gray4"
          >
            <div class="text--right spacing--margin-right">
              <span class="text--bold">
                <ng-container></ng-container>
              </span>
            </div>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="cropAidName">
          <mat-header-cell
            *matHeaderCellDef
            class="flex__child flex__child-2 flex text--bold header-with-background background-color--gray4"
          >
            <div class="spacing--margin-right">
              <span class="text--bold">
                <ng-container>{{ 'name' | translate }}</ng-container>
              </span>
            </div>
          </mat-header-cell>
          <mat-cell *matCellDef="let cropAidImpact" class="flex__child flex__child-2">
            <span
              >{{ cropAidImpact.cropAidName }}
              {{ cropAidImpact.admissionNumber ? '(' + cropAidImpact.admissionNumber + ')' : '' }}</span
            >
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="dosage">
          <mat-header-cell
            *matHeaderCellDef
            class="flex__child flex__child-2 flex text--bold text--center header-with-background background-color--gray4"
            style="justify-content: center"
          >
            <div class="spacing--margin-right text--center">
              {{ 'dosage' | translate }}
            </div>
          </mat-header-cell>
          <mat-cell *matCellDef="let cropAidImpact" class="flex__child flex__child-2" style="justify-content: center">
            <div>{{ cropAidImpact.dosage }} {{ cropAidImpact.unitOfMeasurement }}</div>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="activeIngredientAmount">
          <mat-header-cell
            *matHeaderCellDef
            class="flex__child flex__child-2 flex text--bold header-with-background background-color--gray4"
            style="justify-content: center; margin-right: 0"
          >
            <div class="spacing--margin-right">
              {{ 'activeIngredientKg' | translate }}
            </div>
          </mat-header-cell>
          <mat-cell *matCellDef="let cropAidImpact" class="flex__child flex__child-2" style="justify-content: center">
            <div>
              {{
                cropAidImpact?.activeIngredientAmount !== undefined
                  ? (cropAidImpact?.activeIngredientAmount | number: '1.2-2')
                  : ''
              }}
            </div>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="driftReduction">
          <mat-header-cell
            *matHeaderCellDef
            class="flex__child flex__child-2 flex text--bold header-with-background background-color--gray4"
            style="justify-content: center"
          >
            <div class="spacing--margin-right">
              {{ 'driftReduction' | translate }}
            </div>
          </mat-header-cell>
          <mat-cell *matCellDef="let cropAidImpact" class="flex__child flex__child-2" style="justify-content: center">
            <div>{{ cropAidImpact.driftReduction }}%</div>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="aquaticLife">
          <mat-header-cell
            *matHeaderCellDef
            class="flex__child flex__child-2 flex text--bold descriptive-cell header-with-background background-color--gray4"
            style="justify-content: center"
          >
            <div class="spacing--margin-right">
              {{ 'environmentalImpactPointsAquaticLife' | translate }}
            </div>
          </mat-header-cell>
          <mat-cell
            *matCellDef="let cropAidImpact"
            [class]="{
              flex__child: true,
              'flex__child-2': true,
              'background-color--success-200': hasSuccessBg(cropAidImpact?.aquaticLife),
              'background-color--alert-200': hasAlertBg(cropAidImpact?.aquaticLife),
              'background-color--warn-200': hasWarnBg(cropAidImpact?.aquaticLife),
            }"
            style="justify-content: center"
          >
            <div>
              {{
                cropAidImpact?.aquaticLife || cropAidImpact?.aquaticLife === 0
                  ? (cropAidImpact?.aquaticLife | number: '1.0-0')
                  : ''
              }}
            </div>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="soilLife">
          <mat-header-cell
            *matHeaderCellDef
            class="flex__child flex__child-2 flex text--bold header-with-background background-color--gray4"
            style="justify-content: center"
          >
            <div class="spacing--margin-right">
              {{ 'environmentalImpactPointsSoilLife' | translate }}
            </div>
          </mat-header-cell>
          <mat-cell
            *matCellDef="let cropAidImpact"
            [class]="{
              flex__child: true,
              'flex__child-2': true,
              'background-color--success-200': hasSuccessBg(cropAidImpact?.soilLife),
              'background-color--alert-200': hasAlertBg(cropAidImpact?.soilLife),
              'background-color--warn-200': hasWarnBg(cropAidImpact?.soilLife),
            }"
            style="justify-content: center"
          >
            <div>
              {{
                cropAidImpact?.soilLife || cropAidImpact?.soilLife === 0
                  ? (cropAidImpact?.soilLife | number: '1.0-0')
                  : ''
              }}
            </div>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="groundwaterWashout">
          <mat-header-cell
            *matHeaderCellDef
            class="flex__child flex__child-2 flex text--bold header-with-background background-color--gray4"
            style="justify-content: center"
          >
            <div class="spacing--margin-right">
              {{ 'environmentalImpactPointsGroundWaterWashout' | translate }}
            </div>
          </mat-header-cell>
          <mat-cell
            *matCellDef="let cropAidImpact"
            [class]="{
              flex__child: true,
              'flex__child-2': true,
              'background-color--success-200': hasSuccessBg(cropAidImpact?.groundwaterWashout),
              'background-color--alert-200': hasAlertBg(cropAidImpact?.groundwaterWashout),
              'background-color--warn-200': hasWarnBg(cropAidImpact?.groundwaterWashout),
            }"
            style="justify-content: center"
          >
            <div>
              {{
                cropAidImpact?.groundwaterWashout || cropAidImpact?.groundwaterWashout === 0
                  ? (cropAidImpact?.groundwaterWashout | number: '1.0-0')
                  : ''
              }}
            </div>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="pollinators">
          <mat-header-cell
            *matHeaderCellDef
            class="flex__child flex__child-2 flex text--bold descriptive-cell header-with-background background-color--gray4"
            style="justify-content: center"
          >
            <div class="spacing--margin-right">
              {{ 'pollinators' | translate }}
            </div>
          </mat-header-cell>
          <mat-cell *matCellDef="let cropAidImpact" class="flex__child flex__child-2" style="justify-content: center">
            <div>
              {{ cropAidImpact.pollinators }}
            </div>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="combatants">
          <mat-header-cell
            *matHeaderCellDef
            class="flex__child flex__child-2 flex text--bold header-with-background background-color--gray4"
            style="justify-content: center"
          >
            <div class="spacing--margin-right">
              {{ 'combatants' | translate }}
            </div>
          </mat-header-cell>
          <mat-cell *matCellDef="let cropAidImpact" class="flex__child flex__child-2" style="justify-content: center">
            <div>
              {{ cropAidImpact.combatants }}
            </div>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="totalCaption">
          <mat-footer-cell *matFooterCellDef class="flex__child flex__child-2 flex text--bold">
            <div class="spacing--margin-right">
              {{ 'total' | translate }}
            </div>
          </mat-footer-cell>
        </ng-container>
        <ng-container matColumnDef="total2">
          <mat-footer-cell *matFooterCellDef class="flex__child flex__child-2 flex text--bold">
            <div class="spacing--margin-right"></div>
          </mat-footer-cell>
        </ng-container>
        <ng-container matColumnDef="totalActiveIngredientAmount">
          <mat-footer-cell
            *matFooterCellDef
            class="flex__child flex__child-2 flex text--bold"
            style="justify-content: center"
          >
            <div class="spacing--margin-right">
              {{ data.report.totals?.activeIngredientAmount | number: '1.2-2' }}
            </div>
          </mat-footer-cell>
        </ng-container>
        <ng-container matColumnDef="total4">
          <mat-footer-cell *matFooterCellDef class="flex__child flex__child-2 flex text--bold">
            <div class="spacing--margin-right"></div>
          </mat-footer-cell>
        </ng-container>
        <ng-container matColumnDef="totalAquaticLife">
          <mat-footer-cell
            *matFooterCellDef
            class="flex__child flex__child-2 flex text--bold"
            style="justify-content: center"
          >
            <div class="spacing--margin-right">
              {{ data.report.totals?.aquaticLife | number: '1.0-0' }}
            </div>
          </mat-footer-cell>
        </ng-container>
        <ng-container matColumnDef="totalSoilLife">
          <mat-footer-cell
            *matFooterCellDef
            class="flex__child flex__child-2 flex text--bold"
            style="justify-content: center"
          >
            <div class="spacing--margin-right">
              {{ data.report.totals?.soilLife | number: '1.0-0' }}
            </div>
          </mat-footer-cell>
        </ng-container>
        <ng-container matColumnDef="totalGroundwaterWashout">
          <mat-footer-cell
            *matFooterCellDef
            class="flex__child flex__child-2 flex text--bold"
            style="justify-content: center"
          >
            <div class="spacing--margin-right">
              {{ data.report.totals?.groundwaterWashout | number: '1.0-0' }}
            </div>
          </mat-footer-cell>
        </ng-container>
        <ng-container matColumnDef="total8">
          <mat-footer-cell *matFooterCellDef class="flex__child flex__child-2 flex text--bold">
            <div class="spacing--margin-right"></div>
          </mat-footer-cell>
        </ng-container>
        <ng-container matColumnDef="total9">
          <mat-footer-cell *matFooterCellDef class="flex__child flex__child-2 flex text--bold">
            <div class="spacing--margin-right"></div>
          </mat-footer-cell>
        </ng-container>
        <mat-header-row
          *matHeaderRowDef="['name', 'organicMatterPercentage']"
          class="has-hover-hightlighting"
          data-test="environmental-impact-table__header_first"
        ></mat-header-row>
        <mat-header-row
          *matHeaderRowDef="[
            'cropAidGroup1',
            'cropAidGroup2',
            'cropAidGroup3',
            'cropAidGroup4',
            'environMentalImpactPointsGroup1',
            'environMentalImpactPointsGroup2',
            'environMentalImpactPointsGroup3',
            'usableOrganismsGroup1',
            'usableOrganismsGroup2',
          ]"
          class="has-hover-hightlighting"
          data-test="environmental-impact-table__header_second"
        ></mat-header-row>
        <mat-header-row
          *matHeaderRowDef="displayedColumns; sticky: true"
          class="has-hover-hightlighting"
          data-test="environmental-impact-table__header_third"
        ></mat-header-row>
        <mat-row *matRowDef="let data; columns: displayedColumns" class="has-hover-hightlighting"></mat-row>
        <mat-footer-row
          *matFooterRowDef="displayedTotalColumns; sticky: true"
          class="has-hover-hightlighting"
          data-test="environmental-impact-total-table__footer"
        ></mat-footer-row>
      </mat-table>
    }
    <br /><br />
  </div>
</agr-form-dialog>
